





















import { Vue, Component, Watch } from 'vue-property-decorator';
import { UserApi, User } from '@compassdigital/foodworks.ts.sdk';
import moment from 'moment';
import UserDropdown from '@/components/Stats/UserStats/UserDropdown/index.vue';
import UserTable from '@/components/Stats/UserStats/UserTable/index.vue';
import StatsUtil from '@/util/StatsUtil';
import UserModule from '@/store/modules/user';
import AppModule from '@/store/modules/app';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    UserDropdown,
    UserTable,
  },
})
export default class UserStats extends Vue {
  public users: User [] = [];

  public selectDays: string = moment().subtract(7, 'days').format();

  public userItems: [] = [];

  public userCounts: [] = [];

  public marketsArr: any[] = [];

  public searchMarket: any = '';

  public dateRange: string = '';

  public loading: boolean = false;

  @Watch('searchMarket', { immediate: true })
  marketSearched(val: any) {
    this.getFilteredUsers(val);
  }

  @Watch('selectDays', { immediate: true })
  daysSelected() {
    this.getFilteredUsers(this.searchMarket);
  }

  @Watch('dateRange', { immediate: true })
  timeframeSelected() {
    this.getFilteredUsers(this.searchMarket);
  }

  public getFilteredUsers(marketIds: Array<string>) {
    let users;
    if (marketIds.length > 0) {
      const filteredUsersFor = [];
      const marketsS = marketIds;
      // eslint-disable-next-line no-restricted-syntax
      for (const arr of this.users) {
        // eslint-disable-next-line no-restricted-syntax
        for (const market of (arr as any).markets) {
          // eslint-disable-next-line no-restricted-syntax
          for (const filter of marketsS) {
            if (market === filter) {
              filteredUsersFor.push(arr);
            }
          }
        }
      }
      if (this.dateRange) {
        const prevDate = moment(this.dateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.dateRange.split(' - ')[1]).format('YYYY-MM-DD');
        users = StatsUtil.getCountUsers(
          filteredUsersFor,
          prevDate,
          nextDate,
          true,
        );
      } else {
        users = StatsUtil.getCountUsers(
          filteredUsersFor,
          this.selectDays,
          '',
          false,
        );
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (this.dateRange) {
        const prevDate = moment(this.dateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.dateRange.split(' - ')[1]).format('YYYY-MM-DD');
        users = StatsUtil.getCountUsers(
          this.users,
          prevDate,
          nextDate,
          true,
        );
      } else {
        users = StatsUtil.getCountUsers(
          this.users,
          this.selectDays,
          '',
          false,
        );
      }
    }
    this.userItems = users.fetchedUser;
    this.userCounts = users;
  }

  public mounted() {
    this.getUser();
    this.accessAdminUser();
  }

  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name === 'loading') {
        vm.getUsersNew();
      } else {
        vm.getUser();
      }
    });
  }

  public async getUser() {
    const item = localStorage.getItem('users');
    const userRes = JSON.parse(item as any);
    if (userRes) {
      this.loading = true;
      const mappedUser = await StatsUtil.getMappedMarket(userRes);
      this.users = mappedUser;
      if (mappedUser) {
        const nextDate = '';
        const countUser = await StatsUtil.getCountUsers(this.users,
          this.selectDays,
          nextDate,
          false);
        this.userItems = countUser.fetchedUser;
        this.userCounts = countUser;
        this.loading = false;
      }
    } else {
      this.getCommonUsers();
    }
  }

  public async getUsersNew() {
    const item = localStorage.getItem('users');
    if (item) {
      localStorage.removeItem('users');
    }
    this.getCommonUsers();
  }

  public async getCommonUsers() {
    try {
      this.loading = true;
      const api = new UserApi(AppModule.apiConfig);
      const list = await api.getUsers();
      const mappedUsers = await StatsUtil.getMappedMarket(list.data);
      const nextDates = '';
      if (mappedUsers) {
        localStorage.setItem('users', JSON.stringify(mappedUsers));
        const countUser = await StatsUtil.getCountUsers(mappedUsers,
          this.selectDays,
          nextDates,
          false);
        this.users = mappedUsers;
        this.userItems = countUser.fetchedUser;
        this.userCounts = countUser;
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  public onChangeDays() {
    const nextDate = '';
    const countUser = StatsUtil.getCountUsers(this.users,
      this.selectDays,
      nextDate,
      false);
    this.userItems = countUser.fetchedUser;
    this.userCounts = countUser;
  }

  public onChangeCustomDate(prevDate: string, NextDate: string) {
    const countUser = StatsUtil.getCountUsers(this.users,
      prevDate,
      NextDate,
      true);
    this.userItems = countUser.fetchedUser;
    this.userCounts = countUser;
    this.dateRange = `${moment(prevDate).format('YYYY-MM-DD')} - ${moment(NextDate).format('YYYY-MM-DD')}`;
  }

  public async accessAdminUser() {
    if (UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'fw_admin') {
      const marketsArrs = await StatsUtil.acessMarkets();
      if (marketsArrs) {
        this.marketsArr = marketsArrs;
      }
    }
    return null;
  }
}
